/**
 * The month grid shared by every screen that picks a meeting date.
 *
 * Extracted from BookingWizard on 2026-09-23 when the "renseigner un
 * rendez-vous pris" dialog needed the same grid: one implementation, so the
 * two screens cannot drift on which day a month starts.
 *
 * Day and month names stay in French here on purpose, as they were in the
 * wizard: they are calendar-grid labels, and Intl.DateTimeFormat returns
 * "lun." where the grid shows "Lun", which changes the layout.
 */

export const DAY_LABELS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'] as const;

export const MONTH_NAMES = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
] as const;

/** Month cells, Monday first; null is a leading blank before the 1st. */
export function buildCalendarGrid(year: number, month: number): Array<number | null> {
  const firstDay = new Date(year, month, 1).getDay(); // 0 = Sunday
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const offset = (firstDay + 6) % 7; // shift so Monday = 0
  const cells: Array<number | null> = [];
  for (let i = 0; i < offset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  return cells;
}

export function isDatePast(year: number, month: number, day: number, now: Date = new Date()): boolean {
  const today = new Date(now.getTime());
  today.setHours(0, 0, 0, 0);
  return new Date(year, month, day) < today;
}
